// importing Bootstrap Javascript Module
import Offcanvas from 'bootstrap/js/dist/offcanvas';

// importing GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

let smoother;
function smoothScroll() {
    if(window.innerWidth > 1024) {
        smoother = ScrollSmoother.create({
            smooth: 0.8,
            effects: true,
        });
    }
}

function navbarSection() {
    // navbar drop down
    const navbar = document.querySelector('.navbar');
    const navbarLink = document.querySelectorAll('.navbar__nav-link');
    const dropdownLink = document.querySelectorAll('.dropdown-link');
    const navbarOverlay = document.querySelector('.navbar__overlay');

    if(window.innerWidth > 1024) {
        // navbar drop down
        navbarLink.forEach(e => {
            e.addEventListener('mouseenter', (ev) => {
                navbarLink.forEach(el => {
                    const dropdownWrapper = el.nextElementSibling;
                    if(dropdownWrapper) {
                        dropdownWrapper.classList.remove('show');
                    }
                })

                if(ev.target.classList.contains('dropdown-link')) {    
                    const dropdownWrapperShow = ev.target.nextElementSibling;
                    dropdownWrapperShow.classList.add('show');
                    navbarOverlay.classList.add('show');  
                } else {
                    navbarOverlay.classList.remove('show');  
                }
            })
        })
        navbarOverlay.addEventListener('mouseenter', (ev) => {
            const doc = document.documentElement;
            let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        
            if (top == 0) {
                navbar.classList.remove('scroll');
            }

            navbarLink.forEach(el => {
                const dropdownWrapper = el.nextElementSibling;
                if(dropdownWrapper) {
                    dropdownWrapper.classList.remove('show');
                }
            })
            navbarOverlay.classList.remove('show');
        })
    } else {
        navbarLink.forEach(e => {
            e.addEventListener('click', (ev) => {
                navbarLink.forEach(el => {
                    const dropdownWrapper = el.nextElementSibling;
                    if(dropdownWrapper) {
                        dropdownWrapper.classList.remove('show');
                    }
                })
                
                if(ev.target.classList.contains('dropdown-link')) {    
                    const dropdownWrapperShow = ev.target.nextElementSibling;
                    dropdownWrapperShow.classList.add('show');
                    navbarOverlay.classList.add('show');
                }
            })
        })

        // navbar dropdown on mobile
        const navbarBack = document.querySelectorAll('.navbar__dropdown-right-back');
        const dropdownWrapperMobile = document.querySelectorAll('.navbar__dropdown-wrapper');
        navbarBack.forEach(el => {
            el.addEventListener('click', () => {
                dropdownWrapperMobile.forEach(e => {
                    e.classList.remove('show');
                })
            })
        })
    }

    // navbar color on hover
    navbar.addEventListener('mouseenter', (e) => {
        navbar.classList.add('scroll');
    })
    navbar.addEventListener('mouseleave', (e) => {
        const doc = document.documentElement;
        let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    
        if (top == 0) {
            navbar.classList.remove('scroll');
        }
    })

    // navbar toggler change icon
    if(window.innerWidth <= 1024) {
        const togglerIcon = document.querySelector(".navbar__toggler-icon");
        const offcanvas = document.getElementById("offcanvasNavbar");
        
        const imgSrcOpen = navToggleOpen;
        const imgSrcClose = navToggleClose;
        
        // Event ketika offcanvas mulai ditampilkan
        offcanvas.addEventListener("show.bs.offcanvas", function () {
            togglerIcon.src = imgSrcClose;
        });

        // Event ketika offcanvas mulai ditutup
        offcanvas.addEventListener("hide.bs.offcanvas", function () {
            togglerIcon.src = imgSrcOpen;
        });
    }
}
function navbarOnScroll() {
    const navbar = document.querySelector('.navbar');
    // get window top
    if(window.innerWidth > 1024) {
        const doc = document.documentElement;
        let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    
        if (top == 0) {
            navbar.classList.remove('scroll');
        } else {
            navbar.classList.add('scroll');
        }
    }

    // donation button responsive
    const navbarItemDonation = document.querySelector('.navbar__nav-item--donation');
    const navbarTogglerWrapper = document.querySelector('.navbar__toggler-wrapper');
    const navbarDonationButton = document.querySelector('.navbar__donation-button');
    if (window.innerWidth < 1025) {
        navbarTogglerWrapper.prepend(navbarDonationButton);
    } else {
        navbarItemDonation.append(navbarDonationButton);
    }
}

function footerSocialResponsive() {
    const footerSocialMobileWrapper = document.querySelector('.footer__social-wrapper-mobile');
    const footerSocialCol = document.querySelector('.footer__col--logo-social');
    const footerSocialSection = document.querySelector('.footer__social');
    if (window.innerWidth < 1025) {
        footerSocialMobileWrapper.append(footerSocialSection);
    } else {
        footerSocialCol.append(footerSocialSection);
    }
}

function stopSmoothScrollOnModal() {
    const scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px';
    const customNavbar = document.querySelector('.navbar');

    document.addEventListener('show.bs.modal', () => {
        if(smoother) {
            smoother.kill()
        }
        ScrollTrigger.killAll()
        if (customNavbar) {
            customNavbar.style.paddingRight = scrollbarWidth
        }
    })
    
    document.addEventListener('hidden.bs.modal', () => {
        smoothScroll();
        // fadeUpOnScroll();
        if (customNavbar) {
            customNavbar.style.paddingRight = null
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    smoothScroll();
    navbarSection();
    navbarOnScroll();
    footerSocialResponsive();
    // stopSmoothScrollOnModal();

    let newsletterFormPlaceholder = document.querySelector('.footer__newsletter-form-input');
    let newsletterButton = document.querySelector('.mc4wp-form .theme-button');
    newsletterFormPlaceholder.placeholder = masukkanEmailText;
    newsletterButton.value = langgananText;

    mc4wp.forms.on('submitted', function(form) {
        gsap.to(window, { 
            ease: "Power4.easeInOut",
            duration: 0.4,
            scrollTo: { y: '.footer', offsetY: 0 }
        });
    });
})

document.addEventListener('scroll', () => {
    navbarOnScroll();
});

window.addEventListener("resize", () => {
    navbarOnScroll()
    footerSocialResponsive();
})

export { gsap, ScrollTrigger, ScrollSmoother, smoother }